export const MANUAL_REFERENCE_FILE = 'FCC_Manual_CVale_Final_v4.docx';

export const MANUAL_STRATEGIC_PILLARS = [
  'A C.Vale Alimentos compete por valor, não por preço.',
  'Proteger margem é obrigação comercial e desconto sem contrapartida não é negociação.',
  'Venda de Valor protege margem, margem protegida gera resultado e resultado gera crescimento.',
  'A saída da categoria importa tanto quanto a entrada de pedidos, então mix, giro, execução e exposição precisam entrar na conversa.',
  'Regularidade de fornecimento, qualidade certificada, previsibilidade e inteligência de mercado devem ser defendidos como valor.',
  'O vendedor da C.Vale precisa agir como parceiro estratégico, com leitura de canal, leitura de cliente e visão de longo prazo.',
  'Entender antes de atender é pré-requisito para qualquer negociação de valor.'
];

export const MANUAL_INTERNAL_MARKET_PILLARS = [
  'Mercado interno exige leitura de loja, domínio de PPC e PPV e proposta prática para o PDV.',
  'Ajustar proposta por canal, papel da categoria e lógica de rentabilidade da conta.',
  'Conectar margem, giro, participação, ruptura, mix, PPC, PPV e margem em reais às decisões do cliente.',
  'Negociar contrapartida com clareza quando a conta pedir preço, verba, espaço ou execução diferenciada.'
];

export const MANUAL_EXTERNAL_MARKET_PILLARS = [
  'Mercado externo exige disciplina comercial, clareza documental e defesa firme de preço com base em valor.',
  'Ancorar valor em regularidade, padrão, rastreabilidade, segurança de fornecimento e conformidade.',
  'Reduzir a conversa de preço ao mostrar custo de troca de fornecedor, previsibilidade e calendário de embarque.',
  'Trabalhar relacionamento de longo prazo com lógica de continuidade, serviço e estabilidade comercial.'
];

export const MANUAL_DECOA_MANDATES = [
  'Cuidar do resultado.',
  'Entender o cliente antes de atender.',
  'Fazer bem-feito para todos.',
  'Objetivar o que agrega valor.',
  'Ser mais interessante do que interesseiro.',
  'Ter técnica, consistência e resiliência.'
];

export const MANUAL_MARKET_READING_QUESTIONS = [
  'Qual é o meu cenário atual?',
  'O que a concorrência está fazendo?',
  'Onde está minha maior oportunidade?',
  'Qual é o meu foco da semana?'
];

export const MANUAL_ABSORPTION_NOTE =
  'Manual final incorporado como base estratégica da FCC C.Vale Alimentos para orientar linguagem, rotina comercial, canais, indicadores e padrões de Venda de Valor.';
